import { render } from "./DaDataFeature.vue?vue&type=template&id=5a4c8b7f&scoped=true"
import script from "./DaDataFeature.vue?vue&type=script&lang=js"
export * from "./DaDataFeature.vue?vue&type=script&lang=js"

import "./DaDataFeature.vue?vue&type=style&index=0&id=5a4c8b7f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4c8b7f"]])

export default __exports__